'use client';

import { cn } from '@/lib/tailwind';

type Props = {
    checked: boolean;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    label: string;
    id?: string;
};

// Theme-agnostic switch built on `currentColor`, so it adapts to whatever text
// color the banner uses (white on the dark cookie surface).
export function ConsentToggle({ checked, disabled, onChange, label, id }: Props) {
    return (
        <button
            type="button"
            role="switch"
            id={id}
            aria-checked={checked}
            aria-label={label}
            disabled={disabled}
            onClick={() => onChange?.(!checked)}
            className={cn(
                'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors duration-200',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-current/40',
                checked ? 'border-current bg-current/30' : 'border-current/50 bg-transparent',
                disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
            )}
        >
            <span
                className={cn(
                    'inline-block h-4 w-4 transform rounded-full bg-current transition-transform duration-200',
                    checked ? 'translate-x-5.5' : 'translate-x-1',
                )}
            />
        </button>
    );
}
